module.exports = __webpack_public_path__ + "static/fonts/Sarabun-Regular.81c9617.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Sarabun-Regular.woff
// module id = WAwa
// module chunks = 8